import React, { useCallback } from "react";
import { SwapOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import { connect } from "dva";
import { router } from "umi";
import { getGuidFirst8 } from "@/utils/utils";
const DealerExchangeTag = ({ otherLegId, configPerm, bold }) => {
    const handleClick = useCallback((event) => {
        event?.stopPropagation();
        const path = configPerm["CoreService.AdminShipments"] ? "/admin/shipments/view" : "/shipments/view";
        router.push(`${path}?shipmentId=${otherLegId}`);
    }, [otherLegId, configPerm]);
    if (!otherLegId) {
        return null;
    }
    return (React.createElement(Tag, { color: "processing", icon: React.createElement(SwapOutlined, null), onClick: handleClick, style: { fontWeight: bold ? "bold" : "normal", cursor: "pointer" } },
        "Dealer Exchange With: ",
        getGuidFirst8(otherLegId)));
};
DealerExchangeTag.defaultProps = {
    otherLegId: undefined,
    bold: false,
};
export default connect(({ configs }) => ({
    configPerm: configs.configPerm,
}))(DealerExchangeTag);
